import LoadingSpinner from "components/LoadingSpinner";
import { TabsWrapper } from "components/TabsWrapper/TabsWrapper";
import { TenantFeatureFlag } from "features/saasManagement/TenantConfig/TenantFeatureFlag";
import { tenantFeatureFlagNames } from "features/saasManagement/TenantConfig/tenantConfigConsts";
import { useTitle } from "hooks/useTitle";
import { permissionProfiles } from "../../../../components/Authorize/permissionProfiles";
import { kpiDashboardStyles } from "./KpiDashboardStyles";
import KpiInspection from "./navigations/KpiInspection/KpiInspection";
import KpiOverview from "./navigations/KpiOverview/KpiOverview";
import { useGetCurrentTenantConfigQuery } from "features/me/meSlice";

const KpiDashboardPage = ({ lotId }) => {
    const classes = kpiDashboardStyles();
    useTitle('KPI Dashboard');

    let { data: currentTenantConfig, error, isLoading } = useGetCurrentTenantConfigQuery();
    let inspectionAllowed = currentTenantConfig?.tenantFeatureFlags?.[tenantFeatureFlagNames.UseInspections] === true;

    const isLoadingDashboardData = () => isLoading;

    const tabs = [{
        label: 'Overview',
        component: <KpiOverview />,
        permission: permissionProfiles.DASHBOARD.KPI_DASHBOARD_VIEW_TAB_OVERVIEW
    }];

    if (inspectionAllowed) tabs.push({
        label: 'Inspection',
        component: <KpiInspection lotId={lotId} />,
        permission: permissionProfiles.DASHBOARD.KPI_DASHBOARD_VIEW_TAB_INSPECTION
    });

    return (
        <>
            {
                isLoadingDashboardData() ? <LoadingSpinner loading={isLoadingDashboardData()} /> :
                    <TabsWrapper tabs={tabs} />
            }
        </>
    );
};

export default KpiDashboardPage;
